document.addEventListener('DOMContentLoaded', () => {
  const headerExists = document.querySelector('.header') !== null;

  const globalThemeSwitch = document.querySelector('.global-theme-switch');

  headerExists && globalThemeSwitch && globalThemeSwitch.remove();
});
